"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.DueDatePill = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
var moment_1 = __importDefault(require("moment"));
var modal_1 = require("@hiyllo/ux/modal");
var styled_1 = require("@hiyllo/ux/styled");
var month_calendar_1 = require("@hiyllo/ux/month-calendar");
var common_1 = require("./common");
var PopoutContainer = (0, styled_1.styledRN)(react_native_1.View, function (_a) {
    var $theme = _a.$theme;
    return ({
        backgroundColor: $theme.background2,
        padding: 10,
        borderRadius: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 10
    });
});
exports.DueDatePill = react_1["default"].memo(function DueDatePill(props) {
    var _a, _b, _c, _d;
    var _e = react_1["default"].useState(false), showCalendar = _e[0], setShowCalendar = _e[1];
    var _f = react_1["default"].useState((_b = (_a = props.dueDate) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : new Date()), date = _f[0], setDate = _f[1];
    var close = react_1["default"].useCallback(function () { return setShowCalendar(false); }, []);
    var onChange = react_1["default"].useCallback(function (value) {
        setTimeout(close, 5);
        if (props.onChangeDueDate === null)
            return;
        props.onChangeDueDate(value != null
            ? {
                date: (0, moment_1["default"])(value).toDate(),
                as: "day"
            }
            : null);
    }, [props, close]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(common_1.TaskPill, __assign({ label: "Due", onClick: props.onChangeDueDate != null
                    ? function () { return setShowCalendar(true); }
                    : undefined }, { children: (0, jsx_runtime_1.jsx)(react_native_1.Text, __assign({ style: { color: "white", fontFamily: "hiyllo" } }, { children: props.dueDate !== null
                        ? (0, moment_1["default"])(props.dueDate.date).format("MMM Do")
                        : "None" })) })), showCalendar ? ((0, jsx_runtime_1.jsx)(modal_1.Modal, __assign({ onClose: function () { return setShowCalendar(false); } }, { children: (0, jsx_runtime_1.jsxs)(PopoutContainer, { children: [(0, jsx_runtime_1.jsx)(month_calendar_1.MiniMonthCalendar, { weekOf: (_d = (_c = props.dueDate) === null || _c === void 0 ? void 0 : _c.date) !== null && _d !== void 0 ? _d : date, onChangeDate: onChange, onChangeMonth: setDate, useWeekOfAsActive: true }), (0, jsx_runtime_1.jsx)(common_1.TaskPill, __assign({ onClick: function () { return onChange(null); } }, { children: (0, jsx_runtime_1.jsx)(react_native_1.Text, __assign({ style: { color: "white", fontFamily: "hiyllo" } }, { children: "No Due Date" })) }))] }) }))) : null] }));
});
